export default {
  header: '主頁',
  dashboard: {
    header: '儀表板',
    startDate: '開始日期',
    endDate: '結束日期',
    search: '搜尋',
    static: '統計',
    policyType: '保單類別',
    chart: {
      casesByProvider: '單量/保險公司',
      commissionByProvider: '佣金/保險公司',
      commissionByAgent: '佣金/顧問',
      fycByAgent: '顧問首年佣金（首10名）',
      casesTrend: '單量趨勢',
      fycTrend: '首年佣金趨勢',
      unit: {
        casesByProvider: '交單數量',
        commissionByProvider: '佣金額度',
        commissionByAgent: '佣金額度',
        fycByAgent: '首年佣金額度',
        casesTrend: '交單數量',
        fycTrend: '首年佣金額度'
      }
    }
  },
  message: {
    headers: {
      message: '信息',
      bulletin: '公告',
      birthday: '生日',
      renewal: '續保'
    },
    bulletin: {
      attachment: '附件',
      edit: '編輯附件'
    },
    word: '字',
    createBulletin: '新增公告',
    subject: '主題',
    bulletinSubject: '公告主題',
    bulletinContent: '公告內容',
    category: '分類'
  }
}


// WEBPACK FOOTER //
// ./src/Homepage/langs/zh_hk/index.js